import ListComponent from "@/configurable/components/ListComponent/ListComponent";
import BaseAsset from "@/model/general-assets/BaseAsset";
import BFSearch from "@/modules/abstract-ui/forms/input/BFSearch";
import InfiniteTable from "@/redux/actions/application/application-infinite-table-actions";
import { MatchQuery } from "@/services/DataService";
import classNames from "classnames";
import { nanoid } from "nanoid";
import { useState } from "react";
import { useDispatch } from "react-redux";
import "./SearchList.scss";

const splitUsageInUsefulParts = (usageString: string) => {
  const delimiters = [
    " ",
    // ".",
    ",",
    // "/",
    // "-"
  ];
  const result: { token: string; relevant: boolean }[] = [];

  let currentToken = "";

  for (const char of usageString) {
    const charAsString = char.toString();

    if (delimiters.includes(charAsString)) {
      // Found a delimiter, push the current token if not empty
      if (currentToken.trim() !== "") {
        result.push({ token: currentToken.trim(), relevant: true });
        currentToken = "";
      }

      // Push the delimiter as a separate token
      result.push({ token: charAsString, relevant: false });
    } else {
      // Not a delimiter, append to the current token
      currentToken += charAsString;
    }
  }

  // Push the last token if not empty
  if (currentToken.trim() !== "") {
    result.push({ token: currentToken.trim(), relevant: true });
  }

  return result;
};

interface SearchListProps {
  assetType: string;
  matchQuery?: MatchQuery;
  helpers?: {
    label: string;
    value: string;
  }[];
  renderAsset: (node: BaseAsset) => JSX.Element;
}
const SearchList = (props: SearchListProps) => {
  const dispatch = useDispatch();
  const [tableIdentifier] = useState("table_" + nanoid());
  const [helpers, setHelpers] = useState(
    (props.helpers || []).map((helper) => ({
      label: helper.label,
      parts: splitUsageInUsefulParts(helper.value),
    }))
  );
  return (
    <div className={classNames(`search-list-component`)}>
      <div className={`search-list-header`}>
        <BFSearch focusOnMount tableIdentifier={tableIdentifier} />
        <div className={`receiver-tags helper-tags`}>
          {helpers &&
            helpers.length > 0 &&
            helpers.map((helper, index) => (
              <div className={`search-list-item`} key={index}>
                <span className={`describer`}>{helper.label}</span>
                {helper.parts.map((token) => (
                  <span
                    className={token.relevant ? "token" : ""}
                    onClick={
                      token.relevant
                        ? () => {
                            dispatch(
                              InfiniteTable.setSearch(
                                tableIdentifier,
                                token.token
                              )
                            );
                          }
                        : undefined
                    }
                  >
                    {token.token}
                  </span>
                ))}
              </div>
            ))}
        </div>
      </div>

      <div className={`search-list-result`}>
        <ListComponent
          cleanupOnUnmount
          identifier={tableIdentifier}
          additionalMatchQuery={props.matchQuery}
          assetType={props.assetType}
          asPost
          limitPerRequest={15}
          render={(node: BaseAsset) => {
            return props.renderAsset(node);
          }}
        />
      </div>
    </div>
  );
};

export default SearchList;
